<div *ngIf="hasOnboardingData" class="onboarding-banner" [class.onboarding-banner--uploadedInvoice]="uploadedInvoice">
  <app-onboarding-header
      [title]="onboardingHeaderTitle"
      [subtitle]="onboardingHeaderSubtitle"
    ></app-onboarding-header>
  <div class="onboarding-banner-sub-banners">
    <div *ngIf="!uploadedInvoice" class="onboarding-banner-sub-banner onboarding-banner-sub-banner--upload">
      <app-upload-invoice-milestone></app-upload-invoice-milestone>
    </div>
    <div class="onboarding-banner-sub-banner onboarding-banner-sub-banner--sign">
      <app-sign-documents-milestone
        [signed]="signed"
        [latfStatus]="latfStatus"
        [hasContractReadyToSign]="hasContractReadyToSign"
        (clickEvent)="onSignDocumentsBannerClick($event)"
      ></app-sign-documents-milestone>
    </div>
  </div>
</div>
